<template>
  <div>
    <!--导航栏 start-->
    <div class="main">
      <div class="main-div">
        <van-nav-bar title="菜品统计" left-text="返回" @click-left="onClickLeft" left-arrow fixed />

        <!--导航栏 end-->
        <!--内容 start-->
        <div style="margin-top: 1.2rem">
          <van-search
            v-model="name"
            show-action
            placeholder="请输入菜品名称"
            @search="onSearch"
            @cancel="onCancelName"
          />
          <div>
            <van-cell :value="class_name" is-link title="选择分类" @click="showSheet = true" />
            <van-action-sheet
              title="选择分类"
              v-model="showSheet"
              :actions="classList"
              cancel-text="取消"
              close-on-click-action
              @select="selectList"
              @cancel="onCancel"
            />
          </div>
          <!--时间选择-->
          <!-- 起始时间 -->
          <div id="van-menu-item">
            <div class="starting">
              <van-field
                @click="showPopFn()"
                v-model="timeValue"
                :placeholder="systemTime"
                readonly
              />
            </div>
            <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="选择日期"
                @change="changeFn()"
                @confirm="confirmFn()"
                @cancel="cancelFn()"
              />
            </van-popup>
            <!-- 横线 -->
            <div class="div-hr">
              <hr />
            </div>

            <!-- 结束时间 -->
            <div class="starting">
              <van-field
                @click="showPopFn1()"
                v-model="timeValue1"
                :placeholder="systemTime"
                readonly
              />
            </div>
            <van-popup v-model="show1" position="bottom" :style="{ height: '40%' }">
              <van-datetime-picker
                v-model="currentDate1"
                type="date"
                title="选择日期"
                @change="changeFn1()"
                @confirm="confirmFn1()"
                @cancel="cancelFn1()"
              />
            </van-popup>
          </div>

          <van-tabs
            class="van_tabs"
            color="rgb(0,170,238)"
            title-active-color="black"
            @click="onClick(active)"
            id="vat_tabs"
            v-model="active"
          >
            <van-tab title="日统计">
              <van-grid :column-num="4" :border="false" id="vat_grid">
                <van-grid-item text="菜品名称" />
                <van-grid-item :text="'金额('+food_money+'元)'" />
                <van-grid-item :text="'打包费('+pack_money+'元)'" />
                <van-grid-item :text="'笔数('+total_count+'笔)'" />
              </van-grid>
            </van-tab>
            <van-tab title="周统计">
              <van-grid :column-num="4" :border="false" id="vat_grid">
                <van-grid-item text="菜品名称" />
                <van-grid-item :text="'金额('+food_money+'元)'" />
                <van-grid-item :text="'打包费('+pack_money+'元)'" />
                <van-grid-item :text="'笔数('+total_count+'笔)'" />
              </van-grid>
            </van-tab>
            <van-tab title="月统计">
              <van-grid :column-num="4" :border="false" id="vat_grid">
                <van-grid-item text="菜品名称" />
                <van-grid-item :text="'金额('+food_money+'元)'" />
                <van-grid-item :text="'打包费('+pack_money+'元)'" />
                <van-grid-item :text="'笔数('+total_count+'笔)'" />
              </van-grid>
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </div>
    <!--内容 end-->
    <div class="content">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="report">
        <div v-for="(admin,index) in list" :key="index">
          <van-grid :column-num="4" :border="false">
            <van-grid-item :text="admin.food_name" />
            <van-grid-item :text="admin.food_money" />
            <van-grid-item :text="admin.pack_money" />
            <van-grid-item :text="admin.total_count.toString()" />
          </van-grid>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { Notify, Toast } from "vant";
export default {
  name: "FoodsStatistic", //交易汇总
  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: false,
      forms: "",
      page: 1,
      limit: 10,

      currentDate: new Date(),
      currentDate1: new Date(),
      changeDate: new Date(),
      show: false, // 用来显示弹出层
      show1: false, // 用来显示弹出层
      timeValue: "",
      timeValue1: "",
      //初始化获取当前时间
      systemTime: "",
      select_list: {},
      classList: [],
      class_id: "",
      showSheet: false,
      class_name: "",
      name: "",
      food_money: "",
      pack_money: "",
      total_count:"",
    };
  },
  mounted() {
    this.daily();
    this.addDate();
    this.listClass();
  },
  methods: {
    // 左侧返回
    onClickLeft() {
      //   this.$router.push("/StoreHomepage");
      this.$router.go(-1);
    },
    //初始化时默认是日报表
    daily() {
      this.forms = "1";
      console.log(this.forms);
    },
    //点击报表类型
    onClick(active) {
      if (active == "0") {
        this.forms = "1";
        this.page = 1;
        this.list = [];
        this.report();
        console.log(this.forms);
      } else if (active == "1") {
        this.forms = "2";
        this.page = 1;
        this.list = [];
        this.report();
        console.log(this.forms);
      } else if (active == "2") {
        this.forms = "3";
        this.page = 1;
        this.list = [];
        this.report();
        console.log(this.forms);
      }
    },
    // 触发下拉刷新更多
    // report() {
    //   this.page += 1;
    //   this.report();
    // },
    //统计
    report() {
      var that = this;
      this.$http
        .get("/wechat/api.merchant_info/foodStatic", {
          params: {
            type: this.forms,
            page: this.page,
            limit: this.limit,
            start_time: this.timeValue,
            end_time: this.timeValue1,
            class_id: this.class_id,
            name: this.name,
          },
        })
        .then((response) => {
          //   that.loading = false;
          //   if (response.data.data.data.length) {
          //     that.list.push(...response.data.data.data);
          //     that.finished = false;
          //     console.log("-----", that.list);
          //   } else {
          //     that.finished = true;
          //   }
          // 加载状态结束
          that.loading = false;

          that.list = that.list.concat(response.data.data.data);
          that.pack_money = response.data.data.total.pack_money;
          that.food_money = response.data.data.total.food_money;
          that.total_count = response.data.data.total.total_count;
          // 页码
          that.page++;
          // this.finished = true;
          if (response.data.data.data.length < that.limit) {
            that.finished = true;
          }
        });
    },
    onSearch(v) {
      this.name = v;
      this.page = 1;
      this.list = [];
      this.report();
    },
    onCancelName() {
      this.name = "";
      this.page = 1;
      this.list = [];
      this.report();
    },
    selectList(action, index) {
      console.log(action);
      this.class_name = action.name;
      this.class_id = action.id;
      this.page=1;
      this.show = false;
      this.list = [];
      this.report();
    },
    onCancel() {
      Toast("取消");
      this.class_id = "";
    },
    listClass() {
      this.$http.post("/wechat/api.store_class/listClass").then((response) => {
        if (response && response.body.code == 200) {
          this.classList = response.body.rows;
          // response.body.rows.map(item=>{
          // 	item.name=item.store_name;
          // })
        }
      });
    },
    // 时间选择
    showPopFn() {
      this.show = true;
    },
    showPopFn1() {
      this.show1 = true;
    },
    showPopup() {
      this.show = true;
    },
    showPopup1() {
      this.show = true;
    },
    changeFn() {
      // 值变化是触发
      this.changeDate = this.currentDate; // Tue Sep 08 2020 00:00:00 GMT+0800 (中国标准时间)
    },
    changeFn1() {
      // 值变化是触发
      this.changeDate = this.currentDate1; // Tue Sep 08 2020 00:00:00 GMT+0800 (中国标准时间)
    },
    confirmFn() {
      // 确定按钮
      this.timeValue = this.timeFormat(this.currentDate);
      console.log(this.timeValue);
      this.$store.commit("timer", this.timeValue);
      this.show = false;
      this.page = 1;
      this.list = [];
      this.report();
    },
    confirmFn1() {
      // 确定按钮
      this.timeValue1 = this.timeFormat(this.currentDate1);
      //  console.log(this.timeValue1);
      this.$store.commit("timer1", this.timeValue1);
      this.show1 = false;
      this.page = 1;
      this.list = [];
      this.report();
    },
    cancelFn() {
      this.show = false;
    },
    cancelFn1() {
      this.show1 = false;
    },
    timeFormat(time) {
      // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return year + "-" + month + "-" + day + "";
    },
    addDate() {
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      };
      if (this.$store.state.time != "" && this.$store.state.time1 == "") {
        this.timeValue = this.$store.state.time;
        this.timeValue1 = date.year + "-" + date.month + "-" + date.date;
      } else if (
        this.$store.state.time == "" &&
        this.$store.state.time1 != ""
      ) {
        this.timeValue = date.year + "-" + date.month + "-" + date.date;
        this.timeValue1 = this.$store.state.time1;
      } else if (
        this.$store.state.time != "" &&
        this.$store.state.time1 != ""
      ) {
        this.timeValue = this.$store.state.time;
        this.timeValue1 = this.$store.state.time1;
      } else if (
        this.$store.state.time == "" &&
        this.$store.state.time1 == ""
      ) {
        (this.timeValue = date.year + "-" + date.month + "-" + date.date),
          (this.timeValue1 = date.year + "-" + date.month + "-" + date.date);
      }
    },
  },
};
</script>
<style scoped>
#van-menu-item {
  width: 67%;
  display: flex;
  border-right: none;
  z-index: 100;
  /* border: solid 1px red; */
}
.starting {
  width: 50%;
  background-color: white;
}
.van-popup {
  overflow-y: hidden !important;
}
.div-hr {
  background-color: white;
  height: 1.27rem;
}
hr {
  margin-top: 0.65rem;
  width: 0.4rem;
  background-color: white;
}
</style>